import { Component, Input } from '@angular/core';

/** The four bars of one skeleton card, as the prototype sizes them (P/proto-states.js:51); the second is the 16 px title bar. */
export const SKELETON_BAR_WIDTHS: readonly string[] = ['22%', '68%', '84%', '46%'];

/**
 * Loading placeholder, `.ps-skw` / `.ps-sk` (P/proto-states.js:51, 171-175): `Count` cards of shimmering bars in place of the list
 * or page body that is loading. 3 on Home and the single-record screens, 4 per finder list (:128-130).
 */
@Component({
    standalone: false,
    selector: 'agu-skeleton',
    templateUrl: './skeleton.component.html',
    styleUrl: './skeleton.component.scss',
})
export class AGUSkeletonComponent {
    @Input() Count = 3;

    readonly Bars = SKELETON_BAR_WIDTHS;

    get Cards(): number[] {
        return Array.from({ length: Math.max(0, this.Count) }, (_, i) => i);
    }
}
